import { isEmpty, omit } from 'lodash';

export const getFormattedTags = (data) => {
  let tags = null;
  if (!isEmpty(data?.tags)) {
    tags = { value: [] };
    tags.value = data.tags;
  }
  return tags;
};

export const getAdditionalProps = (catalogCodeCategory, allowNewBids, data) => {
  let additionalProps = null;

  if (catalogCodeCategory === 'Equipment Category') {
    const { sequence, selectionType } = data;
    additionalProps = { sequence: Number(sequence), selectionType };
  }

  if (catalogCodeCategory === 'Fuel Type') {
    const { fastCode, shortHand } = data;
    additionalProps = {
      fastCode,
      shortHand,
      allowNewBids: allowNewBids === 'Y',
    };
  }
  return additionalProps;
};

export const removeCustomSchemaFields = (data, catalogCodeCategory) => {
  const customFields = [
    'sequence',
    'selectionType',
    'fastCode',
    'shortHand',
    'allowNewBids',
  ];

  // POCs only exist on Vehicle Group. Every other category carries an empty
  // object from the form defaults, which has no business in the payload.
  if (catalogCodeCategory !== 'Vehicle Group') {
    customFields.push('vehicleGroupPOCs');
  }

  return omit(data, customFields);
};
